import { render, staticRenderFns } from "./ProcurationStep2.vue?vue&type=template&id=9831881e&scoped=true&"
import script from "./ProcurationStep2.vue?vue&type=script&lang=js&"
export * from "./ProcurationStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9831881e",
  null
  
)

export default component.exports